export default function LoadingBox() {
  return (
    <div className="spinner-border text-warning mt-5 msg carte text-center" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
}
